import {
  createGeocodedForSearchModel,
  IGeocodedForSearchRequestSchema,
} from '@cian/api-models/monolith-csharp/api/geo/geocoded-for-search';
import { getHttpApi } from '@cian/http-api/browser';

export async function getGeocodedSearchData(
  parameters: IGeocodedForSearchRequestSchema,
  subdomain?: string,
) {
  try {
    const httpApi = getHttpApi();
    const { response, statusCode } = await httpApi.fetch(createGeocodedForSearchModel({ parameters }), {
        bodyAsEncodeString: true,
        ecnhancersConfig: {
          timeout: 10000,
        },
        requestConfig: {
          headers: [
            ['Content-Type', 'application/x-www-form-urlencoded'],
          ],
        },
        subdomain: subdomain || 'www',
      },
    );

    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
